import { render, staticRenderFns } from "./MetalManage.vue?vue&type=template&id=14a8ddd0&scoped=true"
import script from "./MetalManage.vue?vue&type=script&lang=js"
export * from "./MetalManage.vue?vue&type=script&lang=js"
import style0 from "./MetalManage.vue?vue&type=style&index=0&id=14a8ddd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a8ddd0",
  null
  
)

export default component.exports